var element = document.getElementById("announcementModal");
var modal = bootstrap.Modal.getOrCreateInstance(element);
if (!sessionStorage.getItem("announcementModalDismissed"))
	modal.show();
element.addEventListener('hidden.bs.modal', function (event) {
	sessionStorage.setItem("announcementModalDismissed", "true");
});
